<template>
  <div class="tip_container">
    <div class="hint_text">
      <p>欢迎老师~，现在扫描下方二维码，</p>
      <p>添加学而思网校企业微信小助手，</p>
      <p>即可进入申领页面哦~</p>
      <!-- <p>请各位老师先添加学而思网校企业微信小助手 </p>
      <p>活动的申请信息将通过短信通知大家</p>
      <p>请留意短信通知哦！</p> -->
    </div>
    <!-- <officialAccount :qrcodeSrc="'https://xesfile.xesimg.com/biz-growth-storage/activity/upload/20200907/1966addd25fcba0cedb01b1adfff2d85.png'"></officialAccount> -->
    <div class="hint_base">
      <img class="qrcode" :src="wxQrcode" />
      <div class="text_container">
        <p class="text_time">
          扫码添加企业微信小助手，快速完成课程申领
        </p>
        <p class="text_mark">注：部分机型识别失败，可保存图片到本地再重试</p>
        <p class="text_mark">五一赠礼全国教师专属企微助手</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'workwxHint',
  data() {
    return {
      wxQrcode: ''
    }
  },
  created() {
    this.wxQrcode = window.atob(this.$route.query.wxQrcode)
  }
}
</script>
<style lang="less" scoped>
.tip_container {
  padding: 0 25px;
  text-align: center;
}

.hint_text {
  padding-top: 159px;

  p {
    font-size: 27/2px;
    font-weight: 400;
    font-family: PingFang SC, PingFang SC-Regular;
    line-height: 20px;
    text-align: center;
    color: #666;
  }
}

.hint_base {
  display: flex;
  align-items: stretch;
  width: 327px;
  // height: 183px;
  padding: 40px 10px 40px 10px;
  margin-top: 70px;
  margin-bottom: 50px;
  background: #fff;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  opacity: 1;

  .qrcode {
    width: 114px;
    height: 114px;
  }

  .text_container {
    display: flex;
    flex-direction: column;
    width: 175px;
    padding: 3px 0;
    margin-left: 15px;
  }

  .text_time {
    margin-bottom: 7px;
    font-size: 16px;
    font-weight: 600;
    font-family: PingFang SC, PingFang SC-Semibold;
    line-height: 22px;
    text-align: left;
    color: #00aced;
  }

  .text_mark {
    display: flex;
    align-items: flex-end;
    flex: 1;
    font-size: 11px;
    font-weight: 400;
    font-family: PingFang SC, PingFang SC-Medium;
    line-height: 1.5;
    text-align: left;
    color: #5e74ac;
  }
}
</style>
